import type { SvpCategory } from '@vgtv/api-client/lib/svp_category';
import { createSelector } from '@reduxjs/toolkit';
import { createSelector as createSelectorReselect } from 'reselect';

import type { Vendor } from '../../types';

import type { CategoriesState } from './index';

type State = { categories: CategoriesState };

export const selectCategories = (state: State, vendor: Vendor) =>
  state.categories[vendor].items;

export const selectCategoriesAsArray = createSelectorReselect(
  selectCategories,
  (categories) => Object.values(categories)
);

export const selectVendorCategories = (state: State, vendor: Vendor) => {
  return state.categories[vendor].items;
};

export const selectCategoryById = (
  state: State,
  vendor: Vendor,
  categoryId?: SvpCategory['id']
) => {
  return categoryId ? state.categories[vendor].items[categoryId] : undefined;
};

export const selectSeriesIdsMap = createSelector(
  (state: State) => state.categories,
  (categories) =>
    Object.entries(categories).map(([vendor, categories]) => {
      return {
        vendor: vendor as Vendor,
        seriesIds: Object.values(categories.items)
          .filter((category) => category.isSeries)
          .map((category) => category.id),
      };
    })
);

export const selectIsRootCategoryMatched = (
  state: State,
  rootCategoryId: SvpCategory['id'],
  vendor?: Vendor,
  categoryId?: SvpCategory['id']
): boolean | undefined => {
  if (categoryId === undefined || vendor === undefined) {
    return false;
  }

  return state.categories[vendor].categoryMappings[rootCategoryId]?.[
    categoryId
  ];
};
